import type { BoxProps } from '@hover/blueprint';
import { Box, Heading } from '@hover/blueprint';
import React from 'react';

import { FastLoader } from 'src/modules/designStudio/components/FastLoader';
import type { PassiveToastType } from 'src/shared/components/Toast/types';

interface PassiveToastBaseProps extends BoxProps {}

interface PassiveToastProps extends PassiveToastBaseProps {
  toast: PassiveToastType;
}

export interface StandalonePassiveToastProps extends PassiveToastBaseProps {
  title: string;
  spinner?: boolean;
}

const StandalonePassiveToast = ({
  title,
  spinner,
  ...props
}: StandalonePassiveToastProps) => (
  <Box
    backgroundColor="neutral000"
    borderRadius={5}
    id="toast"
    paddingX={400}
    paddingY={200}
    shadow="distance300"
    {...props}
  >
    <Box alignItems="center" flex={1}>
      {spinner && (
        <FastLoader color="neutral600" marginRight={100} size="small" />
      )}
      <Heading
        color="neutral600"
        margin={0}
        paddingY={200}
        sx={{ fontSize: 14, marginBottom: 0, lineHeight: 0 }}
      >
        {title}
      </Heading>
    </Box>
  </Box>
);

const PassiveToast = ({ toast, ...props }: PassiveToastProps) => (
  <StandalonePassiveToast {...props} {...toast} />
);

export { PassiveToast, StandalonePassiveToast };
